var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ape-container"},[_c('div',{staticClass:"ape-content"},[_c('router-view')],1),_c('div',{staticClass:"bgRight"},[_c('img',{attrs:{"src":_vm.bgRight}})]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }